import {Serializer} from "../../interfaces/serializer";
import {SavedReport} from "../../interfaces/saved-reports";
import {AdReportParams, AdRequestOptions, AdRequestParams, AdRReportType, ReportTemplate} from '../../interfaces/ad-reports';
import {ParamConfig} from '../../interfaces/params';
import {UserComponentObject} from "../../classes/user-component-object";

export const REPORT_STATE_NAME = 'report';

export interface ReportState {
  downloadLoading: boolean;
  shareLoading: boolean;
}

export interface ReportStoreState {
  uuid: string | null,
  token: string | null,
  type: 'report' | 'template' | 'url' | 'local' | 'public' | null;
  report: Serializer<SavedReport>;
  template: Serializer<ReportTemplate>;
  name: string;
  requestParams: Partial<AdRequestParams> | null;
  requestParamsSubmitted: Partial<AdRequestParams> | null;
  requestOptions: Partial<AdRequestOptions>;
  reportParams: Partial<AdReportParams> | null;
  reportParamsSubmitted: Partial<AdReportParams> | null;
  disabledParams: any;
  reportType: AdRReportType;
  iframe: boolean;
  parameters: any;
  paramsConfigs: Array<ParamConfig>;
  actionsConfigs: Array<ParamConfig>;
  paramsDropdownConfigs: Array<ParamConfig>;
  filtersFromUrl: any;
  periodFromUrl: any;
  helpTemplate: string;
  disabledValues: { [controlName: string]: Array<any> };
  initialized: boolean;
  loading: boolean;
  disabled: boolean;
  submitted: boolean;
  authorize: boolean;
  owner: string;
  limit: number;
}
